/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outdatedbrowser_Continueanyway2Inputs */

const en_outdatedbrowser_continueanyway2 = /** @type {(inputs: Outdatedbrowser_Continueanyway2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue anyway`)
};

/**
* | output |
* | --- |
* | "Continue anyway" |
*
* @param {Outdatedbrowser_Continueanyway2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const outdatedbrowser_continueanyway2 = /** @type {((inputs?: Outdatedbrowser_Continueanyway2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outdatedbrowser_Continueanyway2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outdatedbrowser_continueanyway2(inputs)
});
export { outdatedbrowser_continueanyway2 as "outdatedBrowser_continueAnyway" }